/* eslint-disable react/no-array-index-key */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
import React, { useState } from "react";
import clsx from "clsx";
import { Grid, IconButton } from "@material-ui/core";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { useHistory } from "react-router-dom";
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import { connect, useDispatch, useSelector } from 'react-redux'
import { CustomTab, Button } from "../../atomicComponents";
import WarningModal from "../../components/WarningModal/WarningModal"; 
import {
  ValidatingTextField,
} from "../../components/FormComponents";
import {
  MESSAGE_TYPE,
} from "../../constants";
import UserInfoPanel from "../../atomicComponents/UserInfoPanel/UserInfoPanel";
import BackButton from "../../components/BackButton/BackButton";
import styles from "./ManagerMapping.module.css";
import TableSimple from "../../atomicComponents/TableSimple1/TableSimple";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { setLogin } from '../../redux/features/auth/actions';
import { sanitizeNumeric } from "../../utils/utils";

const ManagerMapping = () => {
  const baseUrl = useSelector(state => state.counter.baseUrl);  // useSelector
  const auth = useSelector((state) => state.auth); // useSelector
  const { showPopup } = usePopupManager(); 
  let {userName, personNumber, companyCode, bookingStatus, costCenter, userRole, sessionId, persArea} = auth;
  const history = useHistory();
  const redirectToApplicationLandingPage = () => {
    history.push("/home");
  };
  const [myState, setState] = React.useState({
    empId: "",
    manager_id: "",
    manager_name: "",
    toDate: null,
    fromDate: null,
    bodyBuilder: null,
    checkFlag: false,
    checkBox: false,
    checkTable: false,
  });
  const [empDetailsSAP, setEmpDetailsSAP] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState("");
  const [managerMapping, setManagerMapping] = useState([]);
  const [isWarningOpen, setIsWarningOpen] = useState(false);
  const [delIndex, setDelIndex] = useState("");
  const dispatch= useDispatch();


  const onChangeHandler = (event) => {
    const { name, value } = event.target;
    setState((prevData) => ({...prevData,[name]: value}));
    
  };
  const getEmpDetails = (manager_name, manager_id, flag) => {
    let apiFormatedData = {
        "pers_no": sanitizeNumeric(myState.empId),
        "MGR_NAME": manager_name,
        "MGR_ID": manager_id,
        "FLAG": flag
    }
    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();
    headerss.append('Content-Type', 'application/json');
    fetch(`${baseUrl}master/getEmpDetails`,
      {
        method: 'POST',
        headers: headerss,
        credentials:'include',
        body: apiFormatedDataJson
      }).then((response) => {
        dispatch(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        if (responseJson) {
          if (flag === 'Y'){
            const empDetails = responseJson[0]
            setEmpDetailsSAP([
                {
                  emp_id: empDetails.pers_no,
                  emp_Name: empDetails.pers_name,
                  manager_id: empDetails.mgr_id,
                  manager_name: empDetails.mgr_name,
                },
          ])
      }
      else if(flag === 'M'){
        let data = []
        responseJson.map((empDetails, index)=>{
            data.push({
              emp_id: empDetails.pers_no,
              emp_Name: empDetails.pers_name,
              manager_id: empDetails.manager_id,
              manager_name : empDetails.manager_name,
              }
          )
        })
        setState((prevData) => ({...prevData,managerMapping:data[0]}));
        setManagerMapping(data)
      }else if(flag === 'Z'){
        setState((prevData) => ({...prevData,"tempManager_id": manager_id, "tempManager_name": responseJson.pers_name}));
  
      }else if(flag === 'D'){
      setManagerMapping([])
      setState((prevData) => ({...prevData,managerMapping:[]}));

      let msg = "Manager mapping deleted successfully."
      showPopup({
        type: MESSAGE_TYPE.SUCCESS,
        contextText: MESSAGE_TYPE.SUCCESS,
        info: msg,
        reloads: true, // Set reload to true or false based on your condition
      });}
    }
    })
    .catch((error) => {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Oops! Something went wrong. Please try again later",
      });
    });
  }
  const getManagerName = (e, key) => {
    const { name, value } = e.target;
    if(e.target.value.length === 6) {
    let apiFormatedData = {
        "pers_no": sanitizeNumeric(e.target.value),
        "MGR_NAME": "",
        "MGR_ID": "",
        "FLAG": "Z"
    }
    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();
    headerss.append('Content-Type', 'application/json');
    fetch(`${baseUrl}master/getEmpDetails`,
      {
        method: 'POST',
        headers: headerss,
        credentials:'include',
        body: apiFormatedDataJson
      }).then((response) => {
        dispatch(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        if (responseJson) {
          if (key === "mapped_manager_name"){
            let prevData = [...managerMapping]
            let updateIndex = {...prevData[selectedIndex], manager_id:e.target.value, manager_name: responseJson.empl_name }
            prevData[selectedIndex] = updateIndex
            setState((prevData) => ({...prevData,managerMapping:updateIndex}));
            setManagerMapping([...prevData])
          }
          else{
          setState((prevData) => ({...prevData,[name]:value, mapping_manager_name: responseJson.empl_name}));
          }
        }
      })
      .catch((error) => {
  
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Oops! Something went wrong. Please try again later",
  
        });
      });
    }
    else if(e.target.value.length < 6 || e.target.value.length > 6) {
      setState((prevData) => ({...prevData,[name]: e.target.value, manager_name:"", mapping_manager_name:""}));
    }
  }
  const getDetails = () =>{
    if(myState.empId.length === 6){
    const getData = getEmpDetails("","","Y")
    const finalData = getEmpDetails(myState.manager_name, myState.manager_id, "M")
    }else{
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please enter valid employee ID.",
      });
    }
  }
  const handleSubmit = () => {
    if(myState.mapping_manager_name){
    const insert = InsertManagerMapping()
    const finalData = getEmpDetails(myState.mapping_manager_name, myState.mapping_manager_id, "M")
    setState((prevData) => ({...prevData,mapping_manager_name:"", mapping_manager_id:""}));
  }else{
    showPopup({
      type: MESSAGE_TYPE.INFORMATION,
      contextText: MESSAGE_TYPE.INFORMATION,
      info: "Please enter valid Manager ID.",
    });
  }
}
  const handleCancel = () => {
    setState((prevData) => ({...prevData,mapping_manager_name:"", mapping_manager_id:""}));
  }
  const handleUpdateMapping = (index) => {
    if (myState.managerMapping["manager_name"]){
    const finalData = getEmpDetails(myState.manager_name, myState.manager_id, "Z")
    const update = InsertManagerMapping("update", index)
    setSelectedIndex("")
    }else{
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please enter valid Manager ID.",
      });
    }
  }
  const InsertManagerMapping = (type, i) => {
    let msg = "Manager mapping inserted successfully" 
    let apiFormatedData = { 
      "empID": myState.empId,
      "MGR_NAME":myState.mapping_manager_name,
      "MGR_ID":myState.mapping_manager_id,
      "comp_code":companyCode,          
      "pers_area":persArea
  }
    if (type === "update"){
      apiFormatedData = { 
        "empID": managerMapping[i].emp_id,
        "MGR_NAME":managerMapping[i].manager_name,
        "MGR_ID":managerMapping[i].manager_id,
        "comp_code":companyCode,          
        "pers_area":persArea
      }
      msg = "Manager mapping updated successfully"
    }
    
  var apiFormatedDataJson = JSON.stringify(apiFormatedData);
  let headerss = new Headers();
  headerss.append('Content-Type', 'application/json');
  fetch(`${baseUrl}master/managerMapping`,
    {
      method: 'POST',
      headers: headerss,
      body: apiFormatedDataJson
    }).then((response) => {
      dispatch(setLogin({...auth, recentStatus: response.status}))
      return response.json();
      })
    .then((responseJson) => {
      if (responseJson) {
        setState((prevData) => ({...prevData, mapped_manager_id: responseJson.data[0].manager_id, mapped_manager_name: responseJson.data[0].manager_name}));
        showPopup({
            type: MESSAGE_TYPE.SUCCESS,
            contextText: MESSAGE_TYPE.SUCCESS,
            info: msg,
            reloads: true, // Set reload to true or false based on your condition

  
          });
          setTimeout(() => {
          getEmpDetails(responseJson.data[0].manager_name, responseJson.data[0].manager_id, "M")

          }, 1500)
      }
    })
    .catch((error) => {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Oops! Something went wrong. Please try again later",
      });
    });
  }
  const handleIDChange = (e, key) => {
    let prevData = [...managerMapping]
    
    let updateIndex = {...prevData[selectedIndex], [key]:e.target.value, "mapped_manager_id": e.target.value}
    getManagerName(e, "mapped_manager_name")  
    prevData[selectedIndex] = updateIndex
    setState((prevData) => ({...prevData,managerMapping:updateIndex}));        
    setManagerMapping([...prevData])
  }
  const deleteMapping = (index) =>{
    setDelIndex(index)
    setIsWarningOpen(true)
  }
  const editMapping = (index) =>{
    console.log(index)
    setSelectedIndex(index)
  }
  
  const renderHTML = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        columns={12}
      >
        <Grid item md={2} lg={2} xs={2} sm={2}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
              <label>Employee Search</label>
            </div>
          </div>
        </Grid>
        <Grid item md={6} lg={7} xs={10} sm={10}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
              <label style={{marginRight:"10px"}}>Employee Id</label>
            </div>
              <ValidatingTextField
                variant="outlined"
                size="small"
                value={myState.empId}
                onChange={(e) => onChangeHandler(e)}
                name="empId"
                inputProps={{
                  "data-testid": "remark-input",
                }}
                style={{ width: "60%" }}
              />

              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                style={{ marginLeft: "10px" }}
                variant="primary"
                onClick={() => getDetails()}
              >
                SUBMIT
              </Button>
           
          </div>
        </Grid>
      </Grid>
    </div>
  );

  const managerDetails = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        columns={12}
      >
        <Grid item md={2} lg={2} xs={12} sm={2}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
              <label>Map Manager Details</label>
            </div>
          </div>
        </Grid>
        <Grid item md={3} lg={3} xs={12} sm={3}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
              <label>Person No:</label>
            </div>
              <ValidatingTextField
                variant="outlined"
                
                isDisabled={true}
                size="small"
                value={myState.empId}
                name="empId"
                InputProps={{
                  className: styles.inputBox,
              }}
                className={styles.inputBox}
                style={{ width: "100%" }}
              />
          </div>
        </Grid>

        <Grid item md={2} lg={2} xs={12} sm={2}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
              <label>Manager Id</label>
            </div>
              <ValidatingTextField
                variant="outlined"
                size="small"
                value={myState.mapping_manager_id}
                onChange={(e) => getManagerName(e)}
                name="mapping_manager_id"
                InputProps={{
                  className: styles.inputBox,
              }}
                style={{ width: "100%" }}
              />
          </div>
        </Grid>

        <Grid item md={3} lg={3} xs={12} sm={3}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
              <label>Manager Name:</label>
            </div>
              <ValidatingTextField
                variant="outlined"
                isDisabled={true}
                size="small"
                value={myState.mapping_manager_name}
                name="manager_name"
                inputProps={{
                  "data-testid": "remark-input",
                }}
                style={{ width: "100%" }}
              />
            </div>
            </Grid>
            <Grid item md={2} lg={2} xs={12} sm={2}>
              <div className={styles.rowDiv}>
              <Button
                className={clsx(styles.actionButton, styles.buttonMargin)}
                variant="primary"
                onClick={(e) => {
                  handleSubmit();
                }}
                data-testid="save-confirm"
              > Save</Button>
              <Button
                 className={clsx(styles.actionButton, styles.resetButton)}
                variant="primary"
                style={{ marginLeft: "10px" }}
                onClick={(e) => { handleCancel()}}
              >Cancel</Button>
            </div>
        </Grid>
      </Grid>
    </div>
  );

  const sapDetails = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        columns={12}
      >
      <Grid item md={2} lg={2} xs={2}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
              <label>Employee Details From SAP :</label>
            </div>
          </div>
          </Grid>
          <Grid item md={10} lg={10} xs={10}>
          <TableSimple
            tableColumnData={empDetailsSAP}
            tableHeaderLabel={[
              "Emp ID",
              "Emp Name",
              "Manager ID",
              "Manager Name",
            ]}
            TableRowHederAling="start"
            size="small"
            headerColor="#E6F2FF"
            className="custom-table"
          />
        </Grid>
      </Grid>
    </div>
  );
  const mappingTable = () => (
    <div className={styles.formGroup}>
    <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={2} lg={2} xs={2} sm={2}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv2)}>
              <label>Employee Details from Manager Mapping Table</label>
            </div>
          </div>
        </Grid>
        <Grid item md={10} lg={10} xs={10} sm={10}>
        <TableSimple
                tableColumnData={[
                  {
                    empId: myState.managerMapping["emp_id"] ?? "",
                    empName: myState.managerMapping["emp_Name"] ?? "",
                    managerId: (selectedIndex.length !== 1 ? <div>{myState.managerMapping["manager_id"]}</div>:
                    <ValidatingTextField
                      variant="outlined"
                      size="small"
                      // isDisabled={activeId}
                      value={myState.managerMapping["manager_id"]}
                      onChange={(e) => handleIDChange(e, "manager_id", selectedIndex)}
                      name="manager_id"
                      inputProps={{
                        "data-testid": "remark-input",
                      }}
                      style={{ width: "100%" }}
                    />
                  ),
                    managerName: myState.managerMapping["manager_name"] ?? "",
                    // workArea: myState.employeDetails["workarea"] ?? "",
                    modifyDetails: (<>{ selectedIndex.length >= 1 ?
                      <IconButton
                      color="primary"
                      className={styles.deleteIcon}
                      onClick={() => {
                        handleUpdateMapping(selectedIndex);
                      }}
                    >
                      <DoneRoundedIcon/>
                    </IconButton> :
                    <IconButton
                        color="primary"
                        className={styles.deleteIcon}
                        onClick={() => {
                          editMapping("0");
                        }}
                      >
                        <EditIcon />
                      </IconButton>
                      
                      }
                      <IconButton style={{ color: "#f17c7c" }}
                        onClick={() => {
                          deleteMapping(0);
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                      </>)
                  },
                ]}
                tableHeaderLabel={[
                  "Emp ID",
                  "Emp Name",
                  "Manager ID",
                  "Manager Name",
                  "Modify Details",
                ]}
                TableRowHederAling="start"
                size="small"
                headerColor="#E6F2FF"
                className="custom-table"
              />
        </Grid>
      </Grid>
    </div>
  )           


  let managerFlag=userRole.includes("M")
  let SAFlag=userRole.includes("SA")

  return (
    <>
    {SAFlag  || managerFlag  ?
    <>
      <div className={styles.container} style={{ boxSizing: "border-box" }}>
            <div className={styles.backButtonLastRefreshedDateWrapper} style={{display:"none"}}>

          <BackButton
            action="Home"
            handleClick={redirectToApplicationLandingPage}
          />
        </div>
        <div className={styles.processHeader}>
          <div className={styles.CustomTabClass}>
            <CustomTab title="Manager Mapping" withOutCount isSelected />
          </div>
          <div className={styles.processTopbar}>
            <UserInfoPanel/>
          </div>
        </div>

        <div
          className={clsx(
            styles.scrollContainer,
            styles.scrollBar,
            styles.formContainer
          )}
        >
          {renderHTML()}
          {empDetailsSAP.length > 0 &&
          <> 
          {sapDetails()}
          
          {
            managerMapping.length === 0 ?
          managerDetails()
            :
          
          mappingTable()
          }
          </>}
          <WarningModal
                    open={isWarningOpen}
                    handleClose={() => setIsWarningOpen(false)}
                    confirmDelete={() => getEmpDetails(managerMapping[delIndex].manager_name, managerMapping[delIndex].manager_id, "D")}
                    msg="Are you sure, you want to delete manager mapping ?"
                  />
        </div>
      </div> 
      </>
      :""}
    </>
  
  );
};

export default ManagerMapping;
